module.exports = __webpack_public_path__ + "media/images/pic/courses/7-ab617a95c1ff2654dbfb04c56275a50d.jpeg";